import { createRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useDevSignIn, useSignIn } from '../auth';
import { m } from '../paraglide/messages';
import { rootRoute } from './root';

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginRoute,
});

function LoginRoute() {
  const signIn = useSignIn();
  const [email, setEmail] = useState('');

  return (
    <div className="card narrow">
      <h1>{m.loginHeading()}</h1>
      <p className="muted">{m.loginIntro()}</p>

      {signIn.isSuccess ? (
        <div className="notice success">
          <strong>{m.loginCheckEmail()}</strong>
          <p className="muted small">{m.loginCheckEmailDetail({ email })}</p>
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const value = email.trim();
            if (!value) return;
            signIn.mutate(value);
          }}
        >
          <label htmlFor="email">{m.loginEmailLabel()}</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={m.loginEmailPlaceholder()}
            disabled={signIn.isPending}
            required
          />
          <button type="submit" disabled={signIn.isPending || !email.trim()}>
            {signIn.isPending ? m.loginSubmitting() : m.loginSubmit()}
          </button>
          {signIn.isError ? <div className="notice error">{m.loginErrorGeneric()}</div> : null}
        </form>
      )}

      {/* Dev-only quick sign-in. Vite's import.meta.env.DEV is the build-
          time flag — this whole block disappears from prod bundles via
          dead-code elimination. The api also rejects /auth/dev-sign-in
          unless BOTH NODE_ENV !== 'production' AND ALLOW_DEV_SIGN_IN=1
          (defense in depth — see apps/api/.env.example). */}
      {import.meta.env.DEV ? <DevSignInButton /> : null}
    </div>
  );
}

function DevSignInButton() {
  const dev = useDevSignIn();
  const navigate = useNavigate();
  return (
    <div
      style={{
        marginTop: '2rem',
        paddingTop: '1rem',
        borderTop: '1px dashed var(--line)',
      }}
    >
      <p className="muted small" style={{ marginBottom: '0.5rem' }}>
        Dev only — skips magic-link round-trip:
      </p>
      <button
        type="button"
        className="btn-ghost"
        disabled={dev.isPending}
        onClick={() =>
          dev.mutate(undefined, {
            onSuccess: () => navigate({ to: '/cases', replace: true }),
          })
        }
      >
        {dev.isPending ? 'Signing in…' : '🛠 Dev sign in (dev@local.test)'}
      </button>
      {dev.isError ? (
        <div className="notice error" style={{ marginTop: '0.5rem' }}>
          Dev sign-in failed — is the api running with NODE_ENV !== 'production'?
        </div>
      ) : null}
    </div>
  );
}
